<template>
  <section>
    <div class="is-flex">
      <ManageUnitySearch
        class="flex-1"
        :itensFilter="getItemsFilter"
        :tabPersistName="tabPersistName"
        isManageOrgan
      />
      <span
        v-if="!isMobile"
        class="p-5 mt-10 is-clickable"
        @click="downloadUnities(true)"
      >
        <b-tooltip
          :type="isContrast ? 'is-white' : 'is-blue-oil'"
          class="list-sign"
          size="is-large"
          position="is-top"
          :label="General.DOWNLOAD"
        >
          <b-icon
            icon="download"
            :type="isContrast ? 'is-white' : 'is-blue-oil'"
          />
        </b-tooltip>
      </span>
    </div>

    <div
      class="level-left has-text-left spacing-mb-10 is-justify-content-space-between is-align-center"
    >
      <div :class="{ 'custom-control-row': isMobile }">
        <span class="has-text-weight-semibold mr-5">
          {{ getPaginationDetails }}
        </span>
        <b-tooltip
          :label="App.ManageUnity.REMOVE_FILTER"
          :type="isContrast ? 'is-white' : 'is-blue-oil'"
          size="is-small"
          position="is-right"
          :active="hasStatusFalse"
        >
          <b-switch
            v-model="viewDisabled"
            :disabled="hasStatusFalse"
            class="vertical-align-sub"
          >
            <span class="has-text-weight-semibold">{{
              General.VIEW_DISABLED
            }}</span>
          </b-switch>
        </b-tooltip>
      </div>

      <section v-if="seeBatchActions" class="buttons">
        <b-button
          :type="isContrast ? 'is-white' : 'is-green-lawn'"
          class="has-text-weight-semibold"
          @click="changeCapacityBatch(true)"
        >
          {{ General.ACTIVATE }}
        </b-button>
        <b-button
          :type="isContrast ? 'is-white' : 'is-green-lawn'"
          class="has-text-weight-semibold"
          @click="changeCapacityBatch(false)"
        >
          {{ General.DISABLE }}
        </b-button>
      </section>
    </div>

    <b-table
      ref="table"
      :data="listPartPagined"
      class="custom-detail-table custom-table-administration custom-5-columns-manage-unity"
      detailType="is-red"
      :checkable="!isMobile"
      hoverable
      :checkedRows.sync="partSelectList"
      :loading="getIsLoadingManageUnity"
    >
      <b-table-column v-slot="props" :label="General.ORGAN_ENTITY">
        <template>
          <div
            class="has-text-color-8 has-text-weight-semibold is-clickable is-uppercase has-text-left"
            @click="toggleDetails(props.row)"
          >
            {{ props.row.name }}
            {{ `- ${props.row.abbreviation}` }}
          </div>
        </template>
      </b-table-column>

      <b-table-column
        :label="App.ManageUnity.SUITE_LEVEL"
        cellClass="has-text-centered is-flex"
      >
        {{ App.ManageUnity.EMPTY_LEVEL }}
      </b-table-column>

      <b-table-column v-slot="props" :label="General.ACTIVE">
        <b-switch
          :value="props.row.has_active_capacity"
          @input="value => changePartState(props.row.id, value)"
        />
      </b-table-column>

      <b-table-column v-slot="props" :label="isMobile ? '' : General.ACTIONS">
        <b-tooltip
          :label="General.EDIT"
          :type="isContrast ? 'is-white' : 'is-blue-oil'"
          size="is-small"
        >
          <span class="is-clickable" @click="editProtocol(props.row)">
            <b-icon
              icon="square-edit-outline"
              :type="isContrast ? 'is-white' : 'is-blue-oil'"
            />
          </span>
        </b-tooltip>
      </b-table-column>

      <template #empty>
        <section class="section">
          <NoListMessage v-if="!isLoading" />
          <b-loading v-else :isFullPage="false" :active="isLoading" />
        </section>
      </template>
    </b-table>

    <div class="pagination-custom mb-10">
      <b-dropdown
        v-model="perPage"
        aria-role="list"
        position="is-top-right"
        :class="{ 'spacing-mb-40': isMobile }"
        :expanded="isMobile"
      >
        <template slot="trigger">
          <b-button class="custom-dropdown-button" :expanded="isMobile">
            {{ perPage }} {{ General.PER_PAGE.toLowerCase() }}
            <b-icon class="spacing-mx-5" icon="chevron-down" />
          </b-button>
        </template>
        <div class="spacing-p-5 has-text-centered">
          {{ General.RECORDS_FOR_PAGE }}
          <div class="list-page">
            <b-dropdown-item
              v-for="option in optionsPagination"
              :key="option"
              :value="option"
            >
              <div>
                {{ option }}
              </div>
            </b-dropdown-item>
          </div>
        </div>
      </b-dropdown>

      <b-pagination
        :total="listFiltered.length"
        :perPage="perPage"
        :current.sync="currentPage"
        rangeBefore="1"
        rangeAfter="1"
        order="is-centered"
        class="process-panel-pagination"
        rounded
        :iconPrev="prevIcon"
        :iconNext="nextIcon"
        :aria-next-label="General.NEXT_PAGE"
        :aria-previous-label="General.PREVIOUS_PAGE"
        :aria-page-label="General.PAGE"
        :aria-current-label="General.CURRENT_PAGE"
      />
    </div>
  </section>
</template>
<script>
import { v4 as uuidv4 } from "uuid";
import { truncate } from "lodash";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { General, App } from "@/utils/constants";
import ManageUnitySearch from "@/components/ManageUnitySearch";
import NoListMessage from "@/components/NoListMessage";
import ListDownloadFiles from "@/components/ListDownloadFiles";
import ModalWarning from "@/views/App/ModalWarning";
import ModalPartPermissionEdit from "@/views/App/ModalPartPermissionEdit";
import { formatPagination } from "@/utils/transformers";
import { TAB_PERSIST_NAME as PERSIST_NAME } from "@/utils/enumerate";

export default {
  name: "ManagePart",

  components: {
    NoListMessage,
    ManageUnitySearch
  },

  data() {
    return {
      perPage: 10,
      currentPage: 1,
      prevIcon: "chevron-left",
      nextIcon: "chevron-right",
      isLoading: false,
      General,
      App,
      viewDisabled: false,
      filterName: "",
      partSelectList: [],
      getItemsFilter: ["CONFIGURATION", "STATUS"]
    };
  },

  computed: {
    ...mapGetters({
      user: "getCurrentUser",
      optionsPagination: "getItensPage",
      getCapacityById: "getCapacityById",
      getManageUnityFilters: "getManageUnityFilters",
      getIsLoadingManageUnity: "getIsLoadingManageUnity",
      getListPart: "getListPart",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),

    seeBatchActions() {
      return this.partSelectList.length;
    },

    listFiltered() {
      const regexp = RegExp(
        (this.filterName || "").replace(/[.*|()]/g, ""),
        "i"
      );
      const list = [];

      for (const part of this.getListPart) {
        const active = part.has_active_capacity;
        if (active || this.viewDisabled) {
          const hasOpenSearch = Boolean(this.filterName || "");
          const checkSearch = !hasOpenSearch || regexp.test(part.searchName);
          const show = checkSearch && this.isFilteredOrgan(part);
          if (show)
            list.push({
              ...part
            });
        }
      }

      return list;
    },

    getPaginationDetails() {
      return formatPagination(
        { count: this.listFiltered.length },
        this.currentPage,
        this.perPage
      );
    },

    listPartPagined() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.listFiltered.slice(start, end);
    },

    hasStatusFalse() {
      const status = this.getManageUnityFilters?.filters?.status;
      return Boolean(status && !status.value);
    },

    filterData() {
      const filters =
        this.getManageUnityFilters?.filters?.configuration?.reduce(
          (acc, actual) => {
            if (!acc[actual.value]) acc[actual.value] = true;
            return acc;
          },
          {}
        ) || {};
      if (
        this.viewDisabled &&
        typeof this.getManageUnityFilters?.filters?.status !== "undefined"
      ) {
        filters.active = this.getManageUnityFilters.filters.status.value;
      } else if (!this.viewDisabled) filters.active = true;
      return filters;
    },

    tabPersistName() {
      return `${PERSIST_NAME.MANAGE_UNITY}_${this.user.id}`;
    }
  },

  watch: {
    filterName() {
      this.currentPage = 1;
    },
    viewDisabled() {
      this.currentPage = 1;
    },
    getManageUnityFilters() {
      this.capacitySelectList = [];
      this.partSelectList = [];
      this.filterName = this.getManageUnityFilters.searchValue;
      this.setIsLoadingManageUnity(false);
    },
    hasStatusFalse(value) {
      if (value) this.viewDisabled = true;
    }
  },

  methods: {
    ...mapActions({
      changeState: "changePartState",
      requestLinkDownloadUnity: "requestLinkDownloadUnity",
      partControlRequest: "partControlRequest"
    }),

    ...mapMutations([
      "setItemDownload",
      "clearListDownloadFiles",
      "setIsLoadingManageUnity"
    ]),

    isFilteredOrgan(part) {
      return this.filterCheckConfig(part) && this.filterCheckStatus(part);
    },

    filterCheckConfig(part) {
      const filterCoreProtocol = this.filterData?.core_protocol;
      return !filterCoreProtocol || Boolean(part.core_protocol);
    },

    filterCheckStatus(part) {
      const filterActiveSelected = typeof this.filterData?.active === "boolean";
      return (
        !filterActiveSelected ||
        this.filterData?.active == part.has_active_capacity
      );
    },

    changeCapacityBatch(active) {
      const list = this.partSelectList.map(part => part.id);

      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: this.General.WARNING,
          message: active
            ? this.General.TEXTS.CONFIRM_ENABLE_CAPACITY_WITH_CHILDREN
            : this.General.TEXTS.CONFIRM_DISABLE_CAPACITY_WITH_CHILDREN,
          confirm: async () => {
            const finalList = list.map(part_id => ({
              part_id,
              active
            }));

            this.isLoading = true;
            await this.changeState(finalList);
            this.partSelectList = [];
            await this.partControlRequest();
            this.isLoading = false;
          },
          buttons: [
            { label: General.YES, isConfirm: false, action: true },
            { label: General.NO, isConfirm: true, action: false }
          ],
          hasCancelAction: true
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    async changePartState(part_id, active) {
      const list = [{ part_id, active }];

      this.isLoading = true;
      await this.changeState(list);
      await this.partControlRequest();
      this.isLoading = false;
    },

    downloadUnities(temp) {
      const file_index = uuidv4();

      if (temp) return;

      const parts_list = this.listFiltered.reduce(
        (acc, part) =>
          acc.concat(
            this.listFilteredCapacityIds(part.id).filter(
              id => this.viewDisabled || this.isActive(id)
            )
          ),
        []
      );

      this.setItemDownload({
        name: App.ManageUnity.NAME_FILE,
        file_index,
        percentage: 0,
        status: "pending"
      });

      this.snackQueue.open({
        id: "download_files",
        parent: this,
        component: ListDownloadFiles,
        closeAction: this.clearListDownloadFiles
      });

      this.requestLinkDownloadUnity({
        ...this.filterData,
        search: this.filterName,
        file_index,
        parts_list
      });
    },

    getAbbreviation(row) {
      return `${truncate(row.description, { length: 80 })}${
        row.abbreviation ? " / " + row.abbreviation : ""
      }`;
    },

    editProtocol(part) {
      const coreProtocolObj = this.getCapacityById(part.core_protocol);
      const coreProtocol = coreProtocolObj
        ? this.getAbbreviation(coreProtocolObj)
        : this.General.TEXTS.NONE;
      this.$buefy.modal.open({
        parent: this,
        component: ModalPartPermissionEdit,
        props: {
          part,
          coreProtocol,
          updateFunction: this.partControlRequest
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    toggleDetails(part) {
      this.$emit("showCapacity", part);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.section {
  display: flex;
  flex-direction: column;
  background-color: $color-1;
  padding: 20px 1.5rem 0 1.5rem;
}
.item-grid {
  display: grid;
  grid-template-columns: 1fr 100px 100px;
  border-bottom: 1px solid $color-7;
  padding-top: 5px;
  padding-bottom: 5px;
}

.custom-control-row {
  @media screen and (max-width: $tablet) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}
</style>
